'use client'

import { useEffect } from 'react'
import { useTranslations } from 'next-intl'
import { EmptyState } from '@node-space/ui-components'
import { ThemedLottie } from '@/app/components/ThemedLottie'
import { logSentryError } from '@/utils/helpers'

interface ErrorProps {
  error: Error
}

const Error = ({ error }: ErrorProps) => {
  const t = useTranslations()

  useEffect(() => {
    // Log the error to an error reporting service
    logSentryError('Global error handler', error, { ...error })
  }, [error])

  return (
    <section className="shadow-elevated bg-background-elevated max-w-[500px] rounded-2xl">
      <div className="flex flex-col gap-3 px-20 py-6">
        <EmptyState
          testId="empty-state"
          title={t('somethingWrongTitle')}
          description={t('somethingWrongMessage')}
          LottiePlayer={<ThemedLottie name="ConnectionError" className="-mb-6" />}
        />
      </div>
    </section>
  )
}

export default Error
